export default {
  navigationBarTitleText: '添加抬头'
};
